import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BeachfrontIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BeachfrontIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.4141 20.7891H20.5653L18.9694 17.5974C18.8702 17.3989 18.6673 17.2735 18.4453 17.2735H14.6421L11.9059 9.10768L18.0184 7.06436C18.3683 6.94737 18.525 6.5387 18.3411 6.21748C16.7647 3.46443 13.5224 2.02603 9.86762 3.01158L9.67633 2.43931C9.57375 2.13243 9.24184 1.96669 8.93484 2.06935C8.62793 2.17197 8.4623 2.50392 8.56492 2.81084L8.75621 3.38311C5.24769 4.79182 3.51745 7.88835 3.91417 11.0403C3.96054 11.4085 4.33222 11.6393 4.68132 11.5228L10.7945 9.47925L13.4062 17.2735H7.69679L2.96737 13.8684C2.70471 13.6793 2.33854 13.7389 2.14948 14.0015C1.96038 14.2641 2.02003 14.6303 2.28261 14.8194L6.8193 18.0858L5.94821 20.7892H2.58594C2.26235 20.7892 2 21.0515 2 21.3751C2 21.6987 2.26234 21.9611 2.58594 21.9611H21.4141C21.7377 21.9611 22 21.6987 22 21.3751C22 21.0515 21.7377 20.7891 21.4141 20.7891ZM9.67765 4.29228C9.67758 4.29232 9.67773 4.29224 9.67765 4.29228C9.68156 4.29283 10.3737 3.96986 11.6058 5.16705C12.2425 5.78568 12.8051 6.60951 13.1744 7.44803L8.78214 8.91631C8.31741 6.93482 8.71023 4.61607 9.67765 4.29228ZM16.9276 6.19338L14.2897 7.07518C13.7841 5.88756 12.9127 4.65967 11.9088 3.87728C13.8963 3.80853 15.7328 4.58548 16.9276 6.19338ZM7.64596 5.30213C7.3119 6.53994 7.35955 8.0451 7.6676 9.28889L5.02888 10.171C5.01689 8.21631 5.97413 6.4719 7.64596 5.30213ZM18.0832 18.4454L19.255 20.7891H15.82L15.0347 18.4454H18.0832ZM7.93459 18.4454H13.7988L14.5841 20.7891H7.17939L7.93459 18.4454Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BeachfrontIcon;
